import React, { useState } from 'react';
import Wrapper from './styles';
import { socialLinks, footerLinks } from "../../utils/constants";
import { Link } from 'react-router-dom';
import { useLanguageContext } from '../../context/language_context';

const Footer = () => {
  const { t } = useLanguageContext();
  const [showPhoneDialog, setShowPhoneDialog] = useState(false);
  const phoneNumber = '54457134';

  const handlePhoneClick = (e, url) => {
    // Check if it's a phone link
    if (url && url.startsWith('tel:')) {
      // Check if mobile device
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      
      if (isMobile) {
        // On mobile, let the default tel: behavior work
        return;
      } else {
        // On desktop, prevent default and show dialog
        e.preventDefault();
        setShowPhoneDialog(true);
      }
    }
  };

  const copyPhoneNumber = () => {
    navigator.clipboard.writeText(phoneNumber);
    alert('Phone number copied: ' + phoneNumber);
    setShowPhoneDialog(false);
  };
  
  return (
    <Wrapper>
      {/* Phone Dialog for Desktop */}
      {showPhoneDialog && (
        <div className="phone-dialog-overlay" onClick={() => setShowPhoneDialog(false)}>
          <div className="phone-dialog" onClick={(e) => e.stopPropagation()}>
            <button className="close-dialog" onClick={() => setShowPhoneDialog(false)}>&times;</button>
            <h4>Contact Us</h4>
            <p className="phone-number">{phoneNumber}</p>
            <button className="copy-btn" onClick={copyPhoneNumber}>
              Copy Number
            </button>
          </div>
        </div>
      )}

      <div className="footerSocialLinks">
        {socialLinks.map((link) => {
          const { url, icon, text } = link;
          return (
            <div key={text}>
              <a href={url} onClick={(e) => handlePhoneClick(e, url)}>{icon}</a>
            </div>
          );
        })}
      </div>
      <div className="footerLinks">
        {footerLinks.map((link) => {
          const { url, text, id } = link;
          return (
            <div key={id}>
              <Link to={url}>{text}</Link>
            </div>
          );
        })}
      </div>
      <div className='underline'>
      </div>
      <h5>
        &copy; 2026
        <span> — </span>
        Built by <a href="https://aminecharrada.netlify.app/" target="_blank" rel="noopener noreferrer" style={{color: 'var(--clr-primary-5)', textDecoration: 'underline'}}>Amine Charrada</a>
      </h5>
    </Wrapper>
  );
};

export default Footer;
